import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../authentication/components/ProtectedRoute';
import OrganizationsPage from '../organizations/pages/OrganizationPage';
import OrganizationCreatePage from '../organizations/pages/OrganizationCreatePage';
import OrganizationEditPage from '../organizations/pages/OrganizationEditPage';
import PlansPage from '../plans/pages/PlansPage';
import PlanCreatePage from '../plans/pages/PlanCreatePage';
import PlanEditPage from '../plans/pages/PlanEditPage';
import PartnersPage from '../partners/pages/PartnerPage';
import PartnerCreatePage from '../partners/pages/PartnerCreatePage';
import PartnerEditPage from '../partners/pages/partnerEditPage';
import SubscriptionsPage from '../subscriptions/pages/SubscriptionPage';
import SubscriptionCreatePage from '../subscriptions/pages/SubscriptionCreatePage';
import SubscriptionEditPage from '../subscriptions/pages/SubscriptionEditPage';
import SubscriptionDetailsPage from '../subscriptions/pages/SubscriptionDetailsPage';
import React from 'react';

const AdminRoutes = () => (
  <>
    {/* Protected Routes */}
    <Route
      path="/organizations"
      element={
        <ProtectedRoute>
          <OrganizationsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/organizations/create"
      element={
        <ProtectedRoute>
          <OrganizationCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/organizations/edit/:id"
      element={
        <ProtectedRoute>
          <OrganizationEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/plans"
      element={
        <ProtectedRoute>
          <PlansPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/plans/create"
      element={
        <ProtectedRoute>
          <PlanCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/plans/edit/:id"
      element={
        <ProtectedRoute>
          <PlanEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/partners"
      element={
        <ProtectedRoute>
          <PartnersPage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/partners/create"
      element={
        <ProtectedRoute>
          <PartnerCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/partners/edit/:id"
      element={
        <ProtectedRoute>
          <PartnerEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions"
      element={
        <ProtectedRoute>
          <SubscriptionsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions/create"
      element={
        <ProtectedRoute>
          <SubscriptionCreatePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions/edit/:id"
      element={
        <ProtectedRoute>
          <SubscriptionEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions/details/:id"
      element={
        <ProtectedRoute>
          <SubscriptionDetailsPage />
        </ProtectedRoute>
      }
    />
  </>
);

export default AdminRoutes;
